// import ReactDOMServer from 'react-dom/server';
class Slide {
    constructor(template, data = {}, id, duration, name) {
        this.template = template;
        this.data = data;
        this.id = id ?? (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
        this.name = name ?? template.name();
        this.duration = duration ?? template.getDuration(); // in seconds
    }

    setData(data) {
        this.data = data;
    }
    getData() {
        return this.data;
    }
    setValue(key, value) {
        this.data[key] = value;
    }
    getValue(key) {
        return this.data[key];
    }
    // toHtml() {
    //     return ReactDOMServer.renderToStaticMarkup(this.render());
    // }
    render() {
        return this.template.render(this.data, this.id);
    }
    actions() {
        return this.template.actions(this.data, this.id);
    }
    getDuration() {
        return this.template.duration;
    }
    toSaveData() {
        return {
            id: this.id,
            type: this.template.type(),
            name: this.name,
            duration: this.duration,
            data: this.data,
            // html: this.toHtml(),
        }
    }
    canDelete() {
        // update, all slide can delete
        return true;
        // return manager.templateManager.startTemplate.type() !== this.template.type()
        //     && manager.templateManager.finishTemplate.type() !== this.template.type()
    }
}

export default Slide;
